import { identity, unsafeCoerce } from 'fp-ts/es6/function';
import { none, some } from 'fp-ts/es6/Option';
import { Iso, Prism } from 'monocle-ts';
/**
 * @since 0.3.0
 */
export var getEq = function (S) { return S; };
/**
 * @since 0.2.0
 */
export var getOrd = function (O) { return O; };
/**
 * @since 0.2.0
 */
export var getSemigroup = function (S) { return S; };
/**
 * @since 0.2.0
 */
export var getMonoid = function (M) { return M; };
/**
 * @since 0.2.0
 */
export var getSemiring = function (S) { return S; };
/**
 * @since 0.2.0
 */
export var getRing = function (R) { return R; };
/**
 * @since 0.2.0
 */
export var getField = function (F) { return F; };
//
// isos
//
var anyIso = 
/*#__PURE__*/
new Iso(unsafeCoerce, unsafeCoerce);
/**
 * @since 0.2.0
 */
export function iso() {
    return anyIso;
}
/**
 * @since 0.2.0
 */
export function prism(predicate) {
    return new Prism(function (s) { return (predicate(s) ? some(s) : none); }, identity);
}
